import axios from "axios";
import baseurl from "./baseurl";
// const httpurl = 'https://hr-api-test.xyjhr.cn'; //测试
// const httpurl = 'http://localhost:28086'; //亚楠本地
// const httpurl = 'http://192.168.31.29:28086'; //亚楠本地
const httpurl = baseurl; //正式 

export default {
    httpurl,
}



// WEBPACK FOOTER //
// ./src/assets/js/url.js